import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const advTag = {
  fetchAdvTag: lazyModuleMethod(() => import('./fetchAdvTag'), 'default'),
  fetchAdvTags: lazyModuleMethod(() => import('./fetchAdvTags'), 'default'),
  createAdvTag: lazyModuleMethod(() => import('./createAdvTag'), 'default'),
  deleteAdvTag: lazyModuleMethod(() => import('./deleteAdvTag'), 'default'),
  editAdvTag: lazyModuleMethod(() => import('./editAdvTag'), 'default'),
}
